(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["single-vs-multi-zone-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const page = root.matches?.('[data-single-multi-page]')
        ? root
        : root.querySelector?.('[data-single-multi-page]');

      if (!page || page.dataset.tabsReady === 'true') return;
      page.dataset.tabsReady = 'true';

      const tabs = Array.from(page.querySelectorAll('[data-room-tab]'));
      const panels = Array.from(page.querySelectorAll('[data-room-panel]'));

      const activateTab = (tab, moveFocus = false) => {
        const room = tab.dataset.roomTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.roomPanel !== room;
        });

        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });
    };

    document.querySelectorAll('[data-single-multi-page]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
